export const WHATSAPP_URL =
  'https://wa.me/5491178249312?text=Hola!%20Quiero%20reservar%20mi%20sesi%C3%B3n%20en%20EscuchaYA'

export const PRICE_LABEL = 'Sesión de 45 minutos · $10.000 ARS'

export const IMAGES = {
  hero: 'https://cdn.magicpatterns.com/uploads/wUK9n2PfYedhR6PpcMZTcr/Hero.webp',
  problem:
    'https://cdn.magicpatterns.com/uploads/cuZr3eU2q68uc7ALyNf8i8/Seccion_El_Problema.webp',
  alone:
    'https://cdn.magicpatterns.com/uploads/v2dXYSERyJWwZw5qxXmahD/Seccion_El_Problema1.webp',
  why: 'https://cdn.magicpatterns.com/uploads/gSeJZjBuw4cyYQv64pGmgw/Por_que_EscuchaYA.webp',
  finalCta:
    'https://cdn.magicpatterns.com/uploads/n4z4GxZfjdGpbcYPTroios/Final_CTA.webp',
}
